export default __webpack_public_path__ + "static/media/book.4af4a7ab.png";